import { AE_SDK_API } from '../types/ae-sdk';
import { getLoadState } from './loadState';
import { monitor } from '@soluto-private/mx-monitor';
import sleep from './sleep';
import { storeAction } from './actionStore';

export type ApiCallback<T> = (sdk: AE_SDK_API) => Promise<T>;

export const unsafeCallApi = async <T>(cb: ApiCallback<T>): Promise<T> => {
    const sdk = await getSDK();
    return await cb(sdk);
};

const getSDK = async (): Promise<AE_SDK_API> =>
    await new Promise<AE_SDK_API>((resolve, reject) => {
        window.AE_SDK((error: Error | null, sdk: AE_SDK_API) =>
            error ? reject(error) : resolve(sdk)
        );
    });

const callApi = async <T>(cb: ApiCallback<T>): Promise<T | undefined> => {
    const loadState = getLoadState();

    if (loadState === 'external_load') {
        const error = new Error('Cannot invoke commands on external AE SDK');
        monitor.warning(error.message, error);
    } else if (loadState === 'error') {
        throw new Error('SDK failed to initialize, cannot invoke functions');
    } else if (loadState === 'loading' || loadState === 'idle') {
        storeAction(cb);
    } else {
        // TODO - Remove sleep after SDK fixes initialization issues
        await sleep(200);
        return await unsafeCallApi(cb);
    }
};

export default callApi;
